'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$30() {
  this.bgR = null;
  this.bgP = null;
  this.bgQ = false;
  this.bgN = null;
  this.bgO = false;
  this.bgS = false;
  this.bgT = false;
  this.bgR = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$30 as $c_Lpresto_PrestoRouter$$anon$30 };
$p = $c_Lpresto_PrestoRouter$$anon$30.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$30;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$30() {
}
export { $h_Lpresto_PrestoRouter$$anon$30 as $h_Lpresto_PrestoRouter$$anon$30 };
$h_Lpresto_PrestoRouter$$anon$30.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bgR;
});
$p.t = (function() {
  if ((!this.bgQ)) {
    this.bgP = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bgQ = true;
  }
  return this.bgP;
});
$p.ae = (function() {
  if ((!this.bgO)) {
    this.bgN = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bgO = true;
  }
  return this.bgN;
});
$p.w = (function() {
  if ((!this.bgT)) {
    this.bgS = false;
    this.bgT = true;
  }
  return this.bgS;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$30 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$30, "presto.PrestoRouter$$anon$30", ({
  NV: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$30 as $d_Lpresto_PrestoRouter$$anon$30 };
//# sourceMappingURL=presto.-Presto-Router$$anon$30.js.map
